module.exports = __webpack_public_path__ + "img/unsung-logo-color.10449a5e.png";